import { Component} from '@angular/core';
import {NgbTabChangeEvent} from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'contact-profile',
	templateUrl: './contact-profile.component.html' 
})

export class ContactprofileComponent {
  	public beforeChange($event: NgbTabChangeEvent) {
      if ($event.nextId === 'tab-preventchange2') {
        $event.preventDefault();
      }
    };
}


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/contact/contact-profile/contact-profile.component.ts